import { render, staticRenderFns } from "./Plazas_en.vue?vue&type=template&id=33891eab&scoped=true&"
import script from "./Plazas_en.vue?vue&type=script&lang=js&"
export * from "./Plazas_en.vue?vue&type=script&lang=js&"
import style0 from "./Plazas_en.vue?vue&type=style&index=0&id=33891eab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33891eab",
  null
  
)

export default component.exports